import type { Assign } from '@ark-ui/react'
import type { IconProps } from '../icon'
import { IconDualColor, type IconDualColorProps } from '../icon-dual-color'
import type { ButtonSharedProps } from './button-root'

type ButtonIconDualColorProps = Assign<
  IconDualColorProps,
  Omit<ButtonSharedProps, 'asIconOnly'>
>

export function ButtonIconDualColor({
  size = 'ml',
  ...props
}: ButtonIconDualColorProps) {
  const sizeToIconSize: Record<
    NonNullable<ButtonSharedProps['size']>,
    IconProps['size']
  > = {
    md: 'extra-small',
    ml: 'small',
    lg: 'small',
    xl: 'small',
  }

  return <IconDualColor.Root {...props} size={sizeToIconSize[size]} />
}

ButtonIconDualColor.displayName = 'ButtonIconDualColor'
